import { array, boolean, number, object, string } from "yup";

export type CouponDiscountType = "percent" | "amount";

export interface CouponValidationResource {
  isValid: boolean;
  validationErrors: string[];
  code: string | null;
  discountType: CouponDiscountType | null;
  discountValue: number | null;
  currency: string | null;
  appliesTo: Record<string, unknown> | null;
}

export const couponValidationResourceSchema = object({
  isValid: boolean().required(),
  validationErrors: array().of(string().required()).required(),
  code: string().nullable().default(null),
  discountType: string<CouponDiscountType>()
    .oneOf(["percent", "amount"])
    .nullable()
    .default(null),
  discountValue: number().nullable().default(null),
  currency: string().nullable().default(null),
  appliesTo: object().nullable().default(null),
});
